import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
export function FinalClose() {
  return <footer id="pricing" className="w-full bg-navy text-cream pt-20 pb-12 px-6 mt-12" data-id="element-40">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-41">
        <h2 className="text-3xl md:text-5xl font-serif font-bold leading-tight" data-id="element-42">
          No necesitas "otra idea".
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto" data-id="element-43">
          Necesitas un sistema que te quite el peso de encima.
        </p>

        <p className="text-lg text-teal font-medium italic" data-id="element-44">
          Planeación 10X: para que tus clases salgan mejor… sin que tu vida se
          vaya en planearlas.
        </p>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 md:p-12 max-w-lg mx-auto mt-8" data-id="element-45">
          {/* Discount Badge */}
          <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-46">
            <span className="bg-teal text-navy font-bold text-sm px-4 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg" data-id="element-47">
              <Zap className="w-4 h-4" data-id="element-48" />
              40% DE DESCUENTO
            </span>
          </div>

          <div className="space-y-6 pt-4" data-id="element-49">
            <h3 className="text-2xl font-serif font-bold text-white" data-id="element-50">
              Planeación 10X
            </h3>

            {/* Price */}
            <div className="flex items-center justify-center gap-4" data-id="element-51">
              <span className="text-xl text-gray-400 line-through" data-id="element-52">
                $499 MXN
              </span>
              <span className="text-5xl md:text-6xl font-black text-white" data-id="element-53">
                $299
              </span>
              <span className="text-lg text-gray-300 self-end mb-1" data-id="element-54">MXN</span>
            </div>

            <p className="text-sm text-teal" data-id="element-55">Pago único — acceso inmediato</p>

            {/* CTA Button */}
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full bg-amber text-navy font-bold text-lg md:text-xl px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center gap-2" data-id="element-56">
              QUIERO PLANEACIÓN 10X
              <ArrowRight className="w-5 h-5" data-id="element-57" />
            </motion.button>

            <p className="text-xs text-gray-400" data-id="element-58">
              Garantía de satisfacción — si no te funciona, pides reembolso sin
              peleas.
            </p>

            {/* What you get */}
            <div className="border-t border-white/10 pt-6 space-y-3 text-left" data-id="element-59">
              <p className="text-xs uppercase tracking-widest text-gray-400 mb-3" data-id="element-60">
                Incluye:
              </p>
              {['Sistema completo Mapa 3C + Bloque 7', 'Protocolo de planeación en 15 minutos', '12 ganchos + Micro-modelos M4', 'Banco de evidencias + Rúbrica de 4 puntos', 'Plantillas editables (Google Docs/Slides)'].map((item, i) => <p key={i} className="text-sm text-gray-300 flex items-start gap-2" data-id="element-61">
                  <span className="text-teal mt-0.5" data-id="element-62">✓</span>
                  {item}
                </p>)}
            </div>
          </div>
        </motion.div>

        <div className="pt-12 border-t border-white/10 text-sm text-gray-400" data-id="element-63">
          <p data-id="element-64">
            © {new Date().getFullYear()} Planeación 10X. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}